import { createContext } from 'react'
import WP_DATA from 'utils/wp_data'

const defaultContext = {
  view: Object.keys(WP_DATA.worksheet_data)[0],
  worksheet_data: WP_DATA.worksheet_data,
  title: WP_DATA.title,
  loading: false,
}

const AppContext = createContext(defaultContext)

export default AppContext

export const LS_KEY = 'SG_CLIENT_PORTAL'